module.exports = __webpack_public_path__ + "img/info.9d7554ba.webp";